/**
 * @summary Available events
 * @enum {string}
 * @memberof PSV.plugins.GyroscopePlugin
 * @constant
 */
export const EVENTS = {
  /**
   * @event gyroscope-updated
   * @memberof PSV.plugins.GyroscopePlugin
   * @summary Triggered when the gyroscope mode is enabled/disabled
   * @param {boolean} enabled
   */
  GYROSCOPE_UPDATED: 'gyroscope-updated',
};
